const BASE_URL = "https://backend.sell30.com/api";

type RequestOptions = {
  method?: "GET" | "POST";
  body?: any;
  token?: string; 
};

async function request(endpoint: string, options: RequestOptions = {}) {
  const { method = "GET", body } = options;
  
  // Local storage se token uthao agar options mein nahi hai
  const savedToken = localStorage.getItem("user_token");
  const finalToken = options.token || savedToken;

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        ...(finalToken ? { Authorization: `Bearer ${finalToken}` } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    const text = await response.text();
    let data = text ? JSON.parse(text) : {};

    if (!response.ok) {
      throw new Error(data.message || "API Error");
    }

    return data;
  } catch (error: any) {
    throw error;
  }
}

export const api = {
  // Simple GET
  get: (endpoint: string) => request(endpoint),
  
  // Simple POST (No explicit token needed, internal logic will check localStorage)
  post: (endpoint: string, body: any) => request(endpoint, { method: "POST", body }),

  // ✅ Authenticated POST (Explicitly for your Payment screen call)
  postAuth: (endpoint: string, body: any, token: string) => 
    request(endpoint, { method: "POST", body, token }),
};